// extracted by mini-css-extract-plugin
export default {"mainSection":"HeroSection_mainSection__N5bhx","hero_cus_b":"HeroSection_hero_cus_b__Rccwe"};